import { connect } from 'react-redux';
import { SurveyList } from '../../components/pages/SurveyList';
import { IApplicationState } from '../../store';
import { ActionCreators as NotificationStoreActionCreators } from '../../store/NotificationStore';
import { ActionCreators } from '../../store/SurveyListStore';

export const SurveyListPage: React.ComponentType<any> = connect(
	(state: IApplicationState) => ({
		...state.surveyList,
		user: state.oidc.user,
	}),
	{
		...ActionCreators,
		...NotificationStoreActionCreators,
	},
)(SurveyList);
